/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "delivery-order-management",
	props:{
		companyId:{
			default: null
		}
	},
	data() {
		return {
			canViewCollectionOrders: true,
			canViewDeliveryOrders: true,
			canViewAllOrdersForCustomers: true,
			disableOrderTypeSelect: false,
			selectedOrderType: null,
			orders: [],
			orderStatuses: [],
			orderTypes: [],
			orderToPlace: null,
			selectOrderTypeModal:{
				modalId: "selectOrderTypeForNewOrderModal",
				heading: "Select Customer For New Order",
				showModal: false
			},
			orderForDeliveryModal: {
				modalId: "createOrderForDeliveryModal",
				heading: "Create New Order For Delivery",
				showModal: false,
				companyId: null,
				company: null
			},
			orderForCollectionModal:{
				modalId: "createOrderForCollectionModal",
				heading: "Create New Order For Collection",
				showModal: false,
				companyId: null,
				company: null
			},
			shippingAddressSelectModal:{
				modalId: "selectShippingAddressForOrderModal",
				heading: "Select Shipping Address For Order",
				showModal: false,
				company: null
			},
			shippingAddressSelectedForOrder: null,
			deliveryOrderHeadings: [
				{
					text: "Order #",
					field: "orderId",
                    id: "orderIdColumn"
				},
				{
					text: "Customer",
					field: "registeredCompanyName",
                    id: "customerColumn"
				},
				{
					text: "Order Date",
					field: "insertedOn",
                    id: "orderDateColumn"
				},
				{
					text: "Expected Date Of Delivery",
					field: "expectedDeliveryDate",
                    id: "expectedDateOfDeliveryColumn"
				},
				{
					text: "Ship Number",
					field: "fleetNumber",
                    id: "shipNumberColumn"
				},
				{
					text: "Driver",
					field: "driver",
                    id: "driverColumn"
				},
				// 	text: "Amount Ordered",
				// 	field: "quantity"
				// },
				// {
				// 	text: "Amount Dispensed",
				// 	field: "quantityDispensed"
				// },
				{
					text: "Customer Purchase Order Number",
					field: "customerPurchaseOrder",
                    id: "customerPurchaseOrderNumberColumn"
				},
				{
					text: "SBO",
					field: "sbo",
                    id: "sboColumn"
				},
				{
					text: "Product",
					field: "product",
                    id: "productColumn"
				},
				{
					text: "Quantity",
					field: "quantity",
                    id: "quantityOrderedColumn"
				},
				{
					text: "Amount Dispensed",
					field: "quantityDispensed",
                    id: "amountDispensedColumn"
				},
				{
					text: "Total",
					field: "totalAsString",
                    id: "totalsColumn"
				},
				{
					text: "Status",
					field: "description",
                    id: "statusColumn"
				}
			],
			reasonForOrderRejection: null,
			headings: [],
			customers: [],
			apiLoaded:{
				customersLoaded: false,
				orderStatusesLoaded: false,
				orderTypesLoaded: false
			},
			firstLoad: false,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actions: [],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				viewOrder: "viewOrder",
				reviewOrder: "reviewOrder",
				viewTrackingHistory: "viewTrackingHistory",
				scheduleOrder: "scheduleOrder",
				rescheduleOrder: "RescheduleOrder",
				viewOrderSchedule: "viewOrderSchedule",
				reasonForCancellation: "reasonForCancellation",
				viewReasonForRejection: "viewReasonForRejection",
				scheduledDeliveryCancelled: "scheduledDeliveryCancelled",
				dispenseOrder: "dispenseOrder",
				viewOrdersInDeliveryBatch: "viewOrdersInDeliveryBatch",
				documents: "documents",
				orderEnquiries: "orderEnquiries",
				viewAudit: "viewAudit"
			},
			reasonForOrderCancellationModal:{
				showModal: false,
				isSaving: false,
				modalId: "reasonForOrderCancellationModal",
				heading: "Reason For Order Cancellation",
				orderId: null,
				orderDeliveryId: null
			},
			trackingHistoryModal:{
				showModal: false,
				isSaving: false,
				modalId: "trackingHistoryModal",
				heading: "Tracking History",
				orderId: null
			},
			orderAuditModal:{
				showModal: false,
				modalId: "orderAuditModal",
				heading: "Order Audit",
				orderId: null
			},
			orderAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditOrderModal",
				heading: "Add Order"
			},
			orderMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveOrderModal",
				heading: "Mark Order As Active/Inactive",
				isActive: null,
				orderId: null
			},
			order:{
				firstName: null,
				lastName: null,
				emailAddress: null
			},
			documentsModal:{
				modalId: "orderDocumentsModal",
				heading: "Order Documents",
				showModal: false,
				orderId: null,
				orderTypeId: null,
                orderStatusId: null
			},
			filterStateChanged: false,
			showExpectedDateOfDeliveryFilter: true,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				orderTypeId: null,
				companyId: null,
				orderStatusId: null,
				expectedDateOfDeliveryToDate: null,
				expectedDateOfDeliveryFromDate: null
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: true,
			selectedHeartbeatStatusCodeId: null,
			stillPendingAfterAllottedTimeFieldName: "stillPendingAfterAllottedTime",
			noDeliveryBatchModal:{
				showModal: false,
				modalId: "noDeliveryBatchModal",
				heading: "No Delivery Batch",
				message: "Order was created before the latest update, therefore this order is not assigned to a delivery batch"
			}
		};
	},
	methods: {
		getUserOrderTypePermissions(){
			this.loading = true;
			securityService.getUserOrderTypePermissions().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.canViewDeliveryOrders = successResponse.data.canAccessDeliveryOrders;
						this.canViewCollectionOrders = successResponse.data.canAccessCollectionOrders;
						this.canViewAllOrdersForCustomers = successResponse.data.canViewAllOrdersForCustomers;
						// this.getOrderStatuses();
						this.getOrderTypes();
						this.getCustomers();
					}
					//this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrders(){
			this.loading = true;
			this.filter.orderTypeId = orderHelper.orderType.delivery;
            this.deliveryOrderHeadings = permissionsHelper.setTableColumnsBasedOnPermissions(this.deliveryOrderHeadings);
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				companyId: this.filter.companyId === 0 ? null : this.filter.companyId,
				orderTypeId: this.filter.orderTypeId,
				orderStatusId: this.filter.orderStatusId,
				createdFrom: this.filter.fromDateCreated,
				createdTo: this.filter.toDateCreated,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				expectedDateOfDeliveryFrom: this.filter.expectedDateOfDeliveryFromDate,
				expectedDateOfDeliveryTo: this.filter.expectedDateOfDeliveryToDate
			};
			orderService.getOrdersForDelivery(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.orders = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						for(let i = 0; i < this.orders.length; i++){
							if(this.orders[i].discountedAmount !== null){
								this.orders[i].totalAmount = this.orders[i].totalAmount - this.orders[i].discountedAmount;
							}
							if(this.orders[i].orderTypeId === orderHelper.orderType.delivery){
								this.orders[i].orderType = "Delivery";
							}
							this.orders[i].totalAsString = currencyHelper.numberToCurrency(this.orders[i].totalAmount);
							this.orders[i].actions = [
								{
									name: "View Order",
									key: this.actionKeys.viewOrder,
									elementId: "btnOrdersViewOrder"
								},
								{
									name: "View Tracking History",
									key: this.actionKeys.viewTrackingHistory,
									elementId: "btnOrdersViewTrackingHistory"
								},
								{
									name: "Order Enquiries",
									key: this.actionKeys.orderEnquiries,
									elementId: "btnOrdersOrderEnquiries"
								},
								{
									name: "View Audit",
									key: this.actionKeys.viewAudit,
									elementId: "btnOrdersViewAudit"
								}
							];
							switch (this.orders[i].orderStatusId){
								case orderHelper.orderStatus.pending:
									this.orders[i].actions.push(
										{
											name: "Review Order",
											key: this.actionKeys.reviewOrder,
											elementId: "btnOrdersReviewOrders"
										}
									);
									break;
								// case orderHelper.orderStatus.accepted:
								// 	this.orders[i].actions.push(
								// 		{
								// 			name: "Schedule Order",
								// 			key: this.actionKeys.scheduleOrder,
								// 			elementId: "btnOrdersScheduleOrder"
								// 		}
								// 	);
								// 	break;
								case orderHelper.orderStatus.scheduledForDelivery:
									this.orders[i].actions.push(
										{
											name: "View Order Schedule",
											key: this.actionKeys.viewOrderSchedule,
											elementId: "btnOrdersViewOrderSchedule"
										},
										{
											name: "View Order In Delivery Batch",
											key: this.actionKeys.viewOrdersInDeliveryBatch,
											elementId: "btnOrdersViewOrderInDeliveryBatch"
										}
									);
									break;
								case orderHelper.orderStatus.scheduledDeliveryCancelled:
									this.orders[i].actions.push(
										{
											name: "View Reason For Cancellation",
											key: this.actionKeys.scheduledDeliveryCancelled,
											elementId: "btnOrdersViewReasonForCancellation"
										}
									);
									this.orders[i].actions.push(
										{
											name: "Reschedule Order",
											key: this.actionKeys.rescheduleOrder,
											elementId: "btnOrdersRescheduleOrder"
										}
									);
									break;
								case orderHelper.orderStatus.rejected:
									this.orders[i].actions.push(
										{
											name: "View Reason For Rejection",
											key: this.actionKeys.viewReasonForRejection,
											elementId: "btnOrdersViewReasonForRejection"
										}
									);
									break;
								case orderHelper.orderStatus.complete:
									this.orders[i].actions.push(
										{
											name: "View Order In Delivery Batch",
											key: this.actionKeys.viewOrdersInDeliveryBatch,
											elementId: "btnOrdersViewOrderInDeliveryBatch"
										}
									);
									this.orders[i].actions.push(
										{
											name: "Documents",
											key: this.actionKeys.documents,
											elementId: "btnOrdersDocuments"
										}
									);
									break;
                                case orderHelper.orderStatus.pendingInvoice:
                                    this.orders[i].actions.push(
                                        {
                                            name: "Documents",
                                            key: this.actionKeys.documents,
                                            elementId: "btnOrdersDocuments"
                                        }
                                    );
                                    break;
							}
						}
						this.orders = dataTableHelper.castFieldValues(this.orders);
						this.filterStateChanged = false;
						permissionsHelper.setControlsBasedOnPermissions();
						let self = this;
						setTimeout(function (){
							self.firstLoad = true;
						}, 500);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrderTypes(){
			this.firstLoad = false;
			this.orderTypes = orderService.getOrderTypes();
			this.orderTypes = $.map(this.orderTypes,
				function (obj) {
					obj.id = obj.id || obj.orderTypeId;
					obj.text = obj.text || obj.description;
					return obj;
				});
			this.apiLoaded.orderTypesLoaded = true;
			if(this.apiLoaded.orderTypesLoaded && this.apiLoaded.customersLoaded){
				this.firstLoad = false;
				if(this.canViewDeliveryOrders && this.canViewCollectionOrders){
					this.filter.orderTypeId = orderHelper.orderType.delivery;
					this.selectedOrderType = "Delivery";
					this.getOrders();
				}
				else if(this.canViewDeliveryOrders){
					this.filter.orderTypeId = orderHelper.orderType.delivery;
					this.selectedOrderType = "Delivery";
					this.disableOrderTypeSelect = true;
					this.getOrders();
				}
				this.getOrderStatuses();
			}
		},
		getOrderStatuses(){
			this.firstLoad = false;
			console.log("order type", this.filter.orderTypeId);
			this.orderStatuses = orderService.getDeliveryOrderStatuses();
			//this.orderStatuses = orderService.getOrderStatuses();
			this.orderStatuses = $.map(this.orderStatuses,
				function (obj) {
					obj.id = obj.id || obj.orderStatusId;
					obj.text = obj.text || obj.description;
					return obj;
				});
			this.orderStatuses.unshift({
				id: 0,
				text: "All"
			});
			this.filter.orderStatusId = 0;
			this.apiLoaded.orderStatusesLoaded = true;
			if(this.apiLoaded.orderTypesLoaded && this.apiLoaded.customersLoaded){
				this.firstLoad = false;
			}
		},
		getCustomers(){
			let request = {
				isActive: true,
				pageNumber: 1,
				pageSize: 3000,
				isDeliveryCompany: true
			};
			this.firstLoad = false;
			customerService.getCompanies(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customers = successResponse.data.result;
						this.customers = dataTableHelper.castFieldValues(this.customers);
						if(this.canViewAllOrdersForCustomers){
							this.customers.unshift({
								companyId: 0,
								registeredCompanyName: "All"
							});
						}
						this.customers = $.map(this.customers,
							function (obj) {
								obj.id = obj.id || obj.companyId;
								obj.text = obj.text || obj.registeredCompanyName;
								return obj;
							});
						if(this.companyId === null || this.companyId === ""){
							this.filter.companyId = this.customers[0].companyId;
						}
						else{
							this.filter.companyId = this.companyId;
						}
						this.apiLoaded.customersLoaded = true;
						if(this.apiLoaded.orderTypesLoaded && this.apiLoaded.customersLoaded){

							// if(orderHelper.orderType.delivery === this.filter.orderTypeId){
							// 	this.getOrders();
							// }
							// else{
							// 	this.getCollectionOrders();
							// }
							if(this.canViewDeliveryOrders && this.canViewCollectionOrders){
								this.filter.orderTypeId = orderHelper.orderType.delivery;
								this.selectedOrderType = "Delivery";
								this.getOrders();
							}
							else if(this.canViewDeliveryOrders){
								this.filter.orderTypeId = orderHelper.orderType.delivery;
								this.selectedOrderType = "Delivery";
								this.disableOrderTypeSelect = true;
								this.getOrders();
							}
							this.getOrderStatuses();
						}
						
						console.log("companyId", this.filter.companyId);
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.pagingDetails = {
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			};
			this.getOrders();
		},
		onPagingUpdated(pagingInfo){
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			//this.getOrders();
			this.getOrders();
		},
		onScheduleOrdersClick(){
			var selectedOrdersForScheduling = localStorageCacheHelper.getSelectedDeliveryOrdersForScheduling();
			if(selectedOrdersForScheduling === null || selectedOrdersForScheduling.length === 0){
				this.$router.push("/orders/delivery/selectDeliveryOrdersForScheduling");
			}
			else{
				//TODO: if sequencing was done, go to components assignment screen
				this.$router.push("/orders/delivery/sequenceDeliveryOrdersForDelivery");
			}
		},
		onExpectedDateOfDeliveryFilterClearClick(){
			this.filter.expectedDateOfDeliveryToDate = null;
			this.filter.expectedDateOfDeliveryFromDate = null;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onExpectedDateOfDeliveryToDateSelect(date){
			this.filter.expectedDateOfDeliveryToDate = date;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onExpectedDateOfDeliveryFromDateSelect(date){
			this.filter.expectedDateOfDeliveryFromDate = date;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onDateFilterClearClick(){
			console.log("clear clicked");
			this.filter.toDateCreated = null;
			this.filter.fromDateCreated = null;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onToDateCreatedSelect(date){
			this.filter.toDateCreated = date;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
			console.log("filter", this.filter);
		},
		onFromDateCreatedSelect(date){
			this.filter.fromDateCreated = date;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
			console.log("filter", this.filter);
		},
		onCustomerFilterSelect(customer){
			this.filter.companyId = customer.id;
			console.log("firstLoad", this.firstLoad)
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onOrderStatusSelect(orderStatus){
			this.filter.orderStatusId = orderStatus.id;
			if(this.firstLoad){
				this.filterStateChanged = true;
			}
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onReasonForCancellationOkButtonClicked(){
			this.reasonForOrderCancellationModal.showModal = false;
		},
		onAddOrderClick(){
			this.selectOrderTypeModal.showModal = true;
		},
		exportOrdersToExcel(){
			this.exportDeliveryOrdersToExcel();
		},
		exportDeliveryOrdersToExcel() {
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				companyId: this.filter.companyId === 0 ? null : this.filter.companyId,
				orderTypeId: this.filter.orderTypeId,
				orderStatusId: this.filter.orderStatusId,
				createdFrom: this.filter.fromDateCreated,
				createdTo: this.filter.toDateCreated,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				expectedDateOfDeliveryFrom: this.filter.expectedDateOfDeliveryFromDate,
				expectedDateOfDeliveryTo: this.filter.expectedDateOfDeliveryToDate
			};
			orderService.getDeliveryOrdersAsExcelDocument(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'Delivery Orders.xlsx');
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onPlaceOrder(orderToPlace){
			this.selectOrderTypeModal.showModal = false;
			let self = this;
			setTimeout(function (){
				if(orderToPlace.orderTypeId === orderHelper.orderType.delivery){
					//self.orderForDeliveryModal.companyId = orderToPlace.companyId;
					//self.orderForDeliveryModal.showModal = true;
					self.shippingAddressSelectModal.showModal = true;
					self.shippingAddressSelectModal.company = orderToPlace.company;
					self.orderToPlace = orderToPlace;
				}
				if(orderToPlace.orderTypeId === orderHelper.orderType.collection){
					// TODO: create modal for collection orders
					self.orderForCollectionModal.companyId = orderToPlace.companyId;
					self.orderForCollectionModal.showModal = true;
					self.orderForCollectionModal.company = orderToPlace.company;
					self.orderToPlace = orderToPlace;
				}
			}, 500);
			console.log("orderToPlace", orderToPlace);
		},
		onShippingAddressSelected(shippingAddress){
			console.log("shippingAddress1", shippingAddress);
			this.shippingAddressSelectedForOrder = shippingAddress;
			this.shippingAddressSelectModal.showModal = false;
			var self = this;
			setTimeout(function(){
				if(shippingAddress !== null) {
					self.orderForDeliveryModal.company = self.shippingAddressSelectModal.company;
					self.orderForDeliveryModal.showModal = true;
				}
			}, 500);
		},
		onPlaceOrderForDeliveryOkClicked(){
			this.orderForDeliveryModal.showModal = false;
			this.filter.orderTypeId = orderHelper.orderType.delivery;
			this.orderForDeliveryModal = {
				modalId: "createOrderForDeliveryModal",
				heading: "Create New Order For Delivery",
				showModal: false,
				companyId: null,
				company: null
			};
			this.shippingAddressSelectModal = {
				modalId: "selectShippingAddressForOrderModal",
				heading: "Select Shipping Address For Order",
				showModal: false,
				company: null
			};
			this.shippingAddressSelectedForOrder = null;
			this.getOrders();
		},
		onTrackingHistoryOkButtonClicked(){
			this.trackingHistoryModal.showModal = false;
		},
		onOrderAuditOkButtonClicked(){
			this.orderAuditModal.showModal = false;
		},
		onOrderActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.viewOrder:
					//this.$router.push("/orders/viewOrder/" + actionAndData.data.orderId + "/" + actionAndData.data.orderDeliveryId + "/" + actionAndData.data.orderDeliveryScheduleId);
					if(actionAndData.data.orderTypeId === orderHelper.orderType.collection){
						this.$router.push("/orders/viewCollectionOrder/" + actionAndData.data.orderId + "/" + actionAndData.data.orderCollectionId);
					}
					if(actionAndData.data.orderTypeId === orderHelper.orderType.delivery) {
						this.$router.push("/orders/viewOrder/" + actionAndData.data.orderId + "/" + actionAndData.data.orderDeliveryId + "/" + actionAndData.data.orderDeliveryScheduleId);
					}
					break;
				case this.actionKeys.reviewOrder:
					this.$router.push("/orders/reviewOrder/" + actionAndData.data.orderId + "/" + actionAndData.data.orderDeliveryId);
					break;
				case this.actionKeys.scheduleOrder:
					if(actionAndData.data.orderDeliveryScheduleId !== null){
						this.$router.push("/orders/scheduleOrderForDelivery/" + actionAndData.data.orderId + "/" + actionAndData.data.orderDeliveryId + "/" + actionAndData.data.orderDeliveryScheduleId);
					}
					else{
						this.$router.push("/orders/scheduleOrderForDelivery/" + actionAndData.data.orderId + "/" + actionAndData.data.orderDeliveryId);
					}
					break;
				case this.actionKeys.viewOrderSchedule:
					if(actionAndData.data.orderDeliveryScheduleId === null){
						this.noDeliveryBatchModal.showModal = true;
					}
					else{
						this.$router.push("/orders/viewOrderSchedule/" + actionAndData.data.orderId + "/" + actionAndData.data.orderDeliveryId + "/" + actionAndData.data.orderDeliveryScheduleId);
					}
					break;
				case this.actionKeys.scheduledDeliveryCancelled:
					this.$router.push("/orders/reasonForDeliveryCancellation/" + actionAndData.data.orderId + "/" + actionAndData.data.orderDeliveryId + "/" + actionAndData.data.orderDeliveryScheduleId);
					break;
				case this.actionKeys.viewReasonForRejection:
					this.reasonForOrderCancellationModal.showModal = true;
					this.reasonForOrderCancellationModal.orderId = actionAndData.data.orderId;
					this.reasonForOrderCancellationModal.orderDeliveryId = actionAndData.data.orderDeliveryId;
					this.reasonForOrderCancellationModal.heading = "Reason For Order Cancellation - #" + actionAndData.data.orderId + " (" + actionAndData.data.registeredCompanyName + ")";
					break;
				case this.actionKeys.viewTrackingHistory:
					this.trackingHistoryModal.showModal = true;
					this.trackingHistoryModal.orderId = actionAndData.data.orderId;
					this.trackingHistoryModal.heading = "Tracking History - #" + actionAndData.data.orderId + " (" + actionAndData.data.registeredCompanyName + ")";
					break;
				case this.actionKeys.viewAudit:
					this.orderAuditModal.showModal = true;
					this.orderAuditModal.orderId = actionAndData.data.orderId;
					this.orderAuditModal.heading = "Order Audit - #" + actionAndData.data.orderId;
				break;				case this.actionKeys.dispenseOrder:
					this.$router.push("/fuelDispensementCapture/" + actionAndData.data.collectionCode + "/" + actionAndData.data.vehicleId);
					break;
				case this.actionKeys.rescheduleOrder:
					this.$router.push("/orders/scheduleOrderForDelivery/" + actionAndData.data.orderId + "/" + actionAndData.data.orderDeliveryId + "/" + actionAndData.data.orderDeliveryScheduleId);
					break;
				case this.actionKeys.viewOrdersInDeliveryBatch:
					if(actionAndData.data.orderDeliveryScheduleId === null){
						this.noDeliveryBatchModal.showModal = true;
					}
					else{
						this.$router.push("/orders/delivery/scheduleDeliveryOrdersForDelivery/" + actionAndData.data.orderDeliveryScheduleId);
					}
					break;
					case this.actionKeys.documents:
						this.documentsModal.showModal = true;
						this.documentsModal.orderId = actionAndData.data.orderId;
						this.documentsModal.heading = "Order Documents - #" + actionAndData.data.orderId;
                        this.documentsModal.orderStatusId = actionAndData.data.orderStatusId;
						this.documentsModal.orderTypeId = orderHelper.orderType.delivery;
						break;
					case this.actionKeys.orderEnquiries:
						this.$router.push("/orders/orderEnquiryMessages/" + actionAndData.data.orderId + "/" + actionAndData.data.companyId + "/" + orderHelper.orderType.delivery + "/" + actionAndData.data.orderStatusId);
						break;
			}
		},
		onNoDeliveryBatchOkClick(){
			this.noDeliveryBatchModal.showModal = false;
		},
		onSelectOrderTypeModalCancelClicked(){
			this.selectOrderTypeModal.showModal = false;
		},
		onMarkUserActiveInactiveSelected(isActive){
			//this.customerMarkAsActiveInactiveModal.isActive = isActive;
			//console.log("customerMarkAsActiveInactiveModal.isActive", this.customerMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			// this.customerMarkAsActiveInactiveModal.isSaving = true;
			// let request = {
			// 	companyId: this.customerMarkAsActiveInactiveModal.companyId,
			// 	isActive: markAsActive
			// };
			// customerService.markCompanyAsActiveOrInactive(request).then(
			// 	successResponse => {
			// 		let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
			// 		if(isSuccess){
			// 			this.getCustomers();
			// 			this.customerMarkAsActiveInactiveModal.showModal = false;
			// 			this.customerMarkAsActiveInactiveModal.isActive = true;
			// 			this.customerMarkAsActiveInactiveModal.companyId = null;
			// 		}
			// 		this.customerMarkAsActiveInactiveModal.isSaving = false;
			// 	},
			// 	errorResponse => {
			// 		console.log("error", errorResponse);
			// 		this.customerMarkAsActiveInactiveModal.isSaving = false;
			// 		apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
			// 	}
			// );
		},
		onDocumentsModalClose(){
			this.documentsModal.showModal = false;
			this.documentsModal.orderId = null;
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Delivery Orders");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Delivery Orders");
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getUserOrderTypePermissions();
		localStorageCacheHelper.removeSelectedOrdersForSchedulingCache();
	},
	watch: {
		companyId: {
			handler: function () {
				// this.getCustomers();
				// if(this.companyId !== null && this.companyId !== ""){
				//	
				// 	this.filter.companyId = parseInt(this.companyId);
				// }
				//this.getOrders();
			},
			immediate: true,
			deep: true
		}
	}
};